//Components
import Carousel, { Item as item } from './Carousel'

export type Item = item
export default Carousel